import { gql } from '@apollo/client';
import _ from 'lodash';

import GET_PROJECT_BY_ID from '../../../components/with-project-sidebar/graphql';
import TestTypes from '../../../../core/constants/testTypes';

const QUERY_LIMIT = 10;
const ORDER = 'created_at DESC';
const OFFSET = 0;
const VALID_BOOKING_STATUS = ['confirmed', 'interview_completed'];
const POOL_INTERVAL = 3000;

const GET_PROJECT_PARTICIPANTS = gql`
  query ProjectParticipants(
    $projectId: ID!,
    $segmentId: ID,
    $tsIsApproved: Boolean,
    $limit: Int!,
    $offset: Int!
    $removed: Boolean
    $bookingStatus: [TestSessionBookingStatusEnum!],
    $testType: TestTypeEnum,
  ) {
    testersCount(
      projectId: $projectId,
      segmentId: $segmentId,
      tsIsApproved: $tsIsApproved,
      removed: $removed,
    )
    segmentsCount(
      projectId: $projectId,
    )
    projectParticipants(
      projectId: $projectId,
      segmentId: $segmentId,
      limit: $limit,
      offset: $offset,
      tsIsApproved: $tsIsApproved,
      removed: $removed,
      bookingStatus: $bookingStatus,
      testType: $testType,
    ) {
      id
      approved
      removed
      qualifiedAt
      userInterviewsParticipantId
      testSessions {
        id
        videoKey
        videoUrl
        status
        approved
        removed
        newVideo
        startAt
        endAt
        bookingStatus
        startUrl
        completedAt
      }
      segment {
        id
        name
        surveys {
          id
          surveyType
          version
          questions {
            id
            label
            questionOrder
            questionOptions {
              id
              label
              disqualify
              qualify
              order
              optionType
            }
          }
        }
      }
      user {
        id
        guest
        email
        referrals {
          id
        }
        profile {
          id
          firstName
          lastName
          jobInfo
          email
          birthdate
          gender
          raceEthnicHeritage
          annualHouseholdIncome
          otherDevices
          country
          state
          currentPosition{
            title
            seniority
            company{
              size
              industry
            }
          }
          jobCategories {
            name
          }
        }
      }
      screenerSession {
        id
        screenerSessionAnswers {
          id
          questionId
          questionOptionId
        }
      }
      segment {
        name
      }
    }
  }
`;

const REMOVE_TESTER = gql`
mutation RemoveTester($id: ID!) {
  removeTester(id: $id) {
    tester {
      id
      removed
    }
  }
}
`;

const updateTesterDeleted = (projectId, removedTester, testType) => (cache) => {
  // update participants list
  const variables = {
    projectId,
    segmentId: null,
    offset: OFFSET,
    limit: QUERY_LIMIT,
    tsIsApproved: true,
    removed: false,
    bookingStatus: VALID_BOOKING_STATUS,
    order: ORDER,
  };

  const cachedProjectParticipants = cache.readQuery({
    query: GET_PROJECT_PARTICIPANTS,
    variables,
  });

  cache.writeQuery({
    query: GET_PROJECT_PARTICIPANTS,
    variables,
    data: {
      projectParticipants: _.filter(cachedProjectParticipants.projectParticipants, ({ id }) => (id !== removedTester)),
      testersCount: cachedProjectParticipants.testersCount - 1,
    },
  });

  // update project status
  const isUpload = testType === TestTypes.UPLOAD;

  if (!isUpload) {
    const cachedProject = cache.readQuery({
      query: GET_PROJECT_BY_ID,
      variables: { id: projectId },
    });

    cache.writeQuery({
      query: GET_PROJECT_BY_ID,
      variables: { id: projectId },
      data: {
        project: {
          ...cachedProject.project,
          status: 'in_progress',
          nlpProcessed: false,
        },
      },
    });
  }
};

export {
  GET_PROJECT_PARTICIPANTS,
  OFFSET,
  ORDER,
  POOL_INTERVAL,
  QUERY_LIMIT,
  REMOVE_TESTER,
  VALID_BOOKING_STATUS,
  updateTesterDeleted,
};
